<template>
  <div id="custom-fields" class="form-inline col-md-12"></div>
</template>

<script>
import CustomFieldsApiRequest from '@/components/ApiRequester/CustomFields';

export default {
  name: 'CustomFields',
  props: {
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    category: {
      type: Number,
      required: false,
      default: () => null,
    },
    internalProduct: {
      type: Number,
      required: false,
      default: () => null,
    },
    series: {
      type: Number,
      required: false,
      default: () => null,
    },
  },
  watch: {
    category() {
      this.fetchCustomFields();
    },
    internalProduct() {
      this.fetchCustomFields();
    },
    series() {
      this.fetchCustomFields();
    },
  },
  data: () => ({
    customFields: [],
  }),
  created() {
    this.fetchCustomFields();
  },
  methods: {
    fetchCustomFields() {
      let payload = {};

      if (this.$props.category !== null) {
        payload = Object.assign(payload, {
          category_id: this.$props.category,
        });
      }

      if (this.$props.internalProduct !== null) {
        payload = Object.assign(payload, {
          product_id: this.$props.internalProduct,
        });
      }

      if (this.$props.series !== null) {
        payload = Object.assign(payload, {
          series_id: this.$props.series,
        });
      }

      if (Object.keys(payload).length > 0) {
        document.getElementById('loader').classList.add('active');
        const ApiRequester = new CustomFieldsApiRequest();
        ApiRequester.all(payload).then((response) => {
          this.customFields = response.data;
          this.renderCustomFields();
          document.getElementById('loader').classList.remove('active');
        }).catch(() => {
          document.getElementById('loader').classList.remove('active');
        });
      }
    },
    renderCustomFields() {
      const parent = document.querySelector('#custom-fields');
      parent.innerHTML = '';

      this.customFields.forEach((customField) => {
        if (customField.type === 'dropdown') {
          customField = Object.assign(customField, {
            type: 'select',
          });
        }

        const formGroup = document.createElement('div');
        formGroup.classList.add('form-group');
        formGroup.classList.add('mb-4');
        formGroup.classList.add('w-100');

        const label = document.createElement('label');
        label.classList.add('pr-4');
        label.innerHTML = customField.label;

        formGroup.append(label);

        parent.append(formGroup);

        let el = null;

        const inputGroup = document.createElement('div');
        inputGroup.classList.add('input-group');
        inputGroup.classList.add('input-group-sm');
        inputGroup.classList.add('px-0');

        if (['input', 'select'].includes(customField.type)) {
          el = document.createElement(customField.type);
          el.classList.add('form-control');
          el.classList.add('form-control-sm');

          if (this.$props.readonly) {
            el.setAttribute('disabled', true);
          }

          if (customField.type === 'input') {
            el.value = customField.properties.value;
            el.type = 'number';
            el.setAttribute('min', 0);
            el.setAttribute('max', 999);
          }

          el.addEventListener('change', (evt) => {
            customField.properties.value = evt.target.value;
            this.$emit('select', this.customFields);
          });

          inputGroup.append(el);
        }

        if (customField.type === 'select') {
          let option = document.createElement('option');
          option.innerHTML = '-- None --';

          el.appendChild(option);

          customField.properties.options.forEach((item) => {
            option = document.createElement('option');
            option.value = item;
            option.innerHTML = item;

            if (item === customField.properties.value) {
              option.setAttribute('selected', true);
            }

            el.appendChild(option);
          });
        }

        if (customField.type === 'checkbox') {
          const div = document.createElement('div');
          div.classList.add('form-check');

          const input = document.createElement('input');
          input.setAttribute('type', 'checkbox');
          input.classList.add('form-check-input');

          input.checked =
            customField.properties.value === ''
              ? false
              : customField.properties.value;

          if (this.$props.readonly) {
            input.setAttribute('disabled', true);
          }

          input.addEventListener('change', (evt) => {
            customField.properties.value = evt.target.checked;
            this.$emit('select', this.customFields);
          });

          div.appendChild(input);

          inputGroup.append(div);
        }

        if (['input', 'select'].includes(customField.type) && !['', null].includes(customField.properties.label)) {
          const inputGroupPrepend = document.createElement('div');
          inputGroupPrepend.classList.add('input-group-prepend');

          const inputGroupText = document.createElement('span');
          inputGroupText.classList.add('input-group-text');
          inputGroupText.innerHTML = customField.properties.label;

          inputGroupPrepend.append(inputGroupText);
          inputGroup.append(inputGroupPrepend);
        }

        if (customField.type === 'multiple-input') {
          customField.properties.forEach((property) => {
            const el = document.createElement(property.type);
            el.value = property.value;

            if (this.$props.readonly) {
              el.setAttribute('disabled', true);
            }

            el.addEventListener('change', (event) => {
              property.value = event.target.value;
            });

            switch (property.type) {
              case 'input': {
                el.classList.add('form-control');
                el.classList.add('form-control-sm');

                const inputGroup = document.createElement('div');
                inputGroup.classList.add('input-group');
                inputGroup.classList.add('input-group-sm');
                inputGroup.classList.add('px-0');
                inputGroup.style.cssText = 'width: 100px !important;';
                inputGroup.append(el);

                const inputGroupPrepend = document.createElement('div');
                inputGroupPrepend.classList.add('input-group-prepend');

                const inputGroupText = document.createElement('span');
                inputGroupText.classList.add('input-group-text');
                inputGroupText.innerHTML = property.label;

                inputGroupPrepend.append(inputGroupText);
                inputGroup.append(inputGroupPrepend);
                formGroup.append(inputGroup);

                break;
              }
              case 'label': {
                el.innerHTML = property.value;
                el.classList.add('mx-2');
                formGroup.append(el);
                break;
              }
            }
          });
        }

        formGroup.append(inputGroup);
      });

      this.$emit('select', this.customFields);
    },
  },
};
</script>
